<!--
 * @Author: your name
 * @Date: 2020-07-02 17:41:15
 * @LastEditTime: 2020-07-21 15:44:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Parts_APP\src\App.vue
-->
<template>
    <div id="app">
<keep-alive >
		<!-- 当前进入的路由 meta里面 keepAlive为true时走这里 -->
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- <goUp /> -->
    </div>
</template>
<script>
// import goUp from './components/goUp'

export default {
    // name: 'App',
    // components: {
    //     goUp
    // },
    // created() {
    // // 在页面加载时读取sessionStorage里的状态信息
    //     if (sessionStorage.getItem('store')) {
    //         this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
    //     }

    //     // 在页面刷新时将vuex里的信息保存到sessionStorage里
    //     window.addEventListener('beforeunload', () => {
    //         sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    //     })
    // }
    name: 'App',
    mounted() {
        // this.$router.push('/')
    }
}
</script>
<style lang="scss">
// #app{
//   height: 100%;
// }
// .van-pull-refresh{
//   overflow: visible!important;
// }
.van-nav-bar{
    height: 50px!important;
}
.nav{
  width: 100%;
  padding: 20px 0px;
  background: #3498ff;
  color: #fff;
  .nav-title{
    width: 100%;
    font-size: 30px;
    text-align: center;
    display: block;
  }
}
.button-text{
  color: #1890ff;
 cursor:pointer;
}
.van-toast{
  line-height:0.45rem;
}
.van-toast--middle {
  min-width: 30%;
  height: 10%;
  font-size: 28px;
}
.van-icon{
  font-size: 28px;
}
.van-toast__text{
  font-size: 28px;
}
.hidden{
  height: 100%;
  overflow: hidden;
}
.listp{
  width: 100%;
}
.margin-top5{
margin-top: 5px
}
.tq-table-rom-header{
  background: #eef1f6 !important;
  color: #606266 !important;
}
.van-grid-item__content::after{
    border-width:0rem
}

.van-nav-bar__arrow{
  font-size: 0.5rem;
}
</style>
